/**
 * Deed Recording Cover Sheet
 * Phase 2 document for real estate contributions
 * No signatures required - administrative document
 */

import { replaceMergeFields, getAllMergeFields } from './mergeFields';

export function generateDeedRecordingCoverSheetHtml(
  workflowData: any,
  unaData: any
): string {
  const mergeFields = getAllMergeFields(workflowData, unaData);
  
  const template = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    @page {
      size: Letter;
      margin: 0.75in;
    }
    body {
      font-family: Cambria, Georgia, 'Times New Roman', serif;
      font-size: 11pt;
      line-height: 1.85;
      color: #1a1a1a;
      max-width: 8.5in;
      margin: 0 auto;
      padding: 0;
    }
    .header {
      text-align: center;
      border-bottom: 2px solid #c9a961;
      padding-bottom: 18pt;
      margin-bottom: 24pt;
    }
    h1 {
      font-size: 18pt;
      font-weight: bold;
      margin: 0 0 10pt 0;
      text-transform: uppercase;
      letter-spacing: 0.12em;
    }
    .section {
      margin: 20pt 0;
    }
    .section-title {
      font-weight: bold;
      font-size: 11pt;
      text-transform: uppercase;
      margin-bottom: 12pt;
      border-bottom: 1px solid #bfbfbf;
      padding-bottom: 6pt;
      color: #262626;
    }
    .field-group {
      margin: 10pt 0;
    }
    .field-label {
      font-weight: bold;
      display: inline-block;
      min-width: 2.5in;
    }
    .instruction-box {
      border: 2px solid #c9a961;
      padding: 16pt;
      margin: 20pt 0;
      background-color: #fafafa;
      border-radius: 4pt;
    }
    .instruction-title {
      font-weight: bold;
      font-size: 11pt;
      margin-bottom: 10pt;
    }
    .checkbox {
      display: inline-block;
      width: 12pt;
      height: 12pt;
      border: 1px solid #333;
      margin-right: 8pt;
      vertical-align: middle;
    }
    .footer {
      margin-top: 36pt;
      font-size: 9pt;
      color: #666;
      text-align: center;
      border-top: 1px solid #ccc;
      padding-top: 16pt;
    }
  </style>
</head>
<body>
  <div class="header">
    <h1>Real Property Recording Cover Sheet</h1>
    <div style="font-size: 10pt; color: #444;">
      For Recorder's Office Use - {{property_county}} County, {{property_state}}
    </div>
  </div>
  
  <div class="section">
    <div class="section-title">Property Information</div>
    <div class="field-group">
      <span class="field-label">Property Address:</span>
      {{property_address}}, {{property_city}}, {{property_state}} {{property_zip}}
    </div>
    <div class="field-group">
      <span class="field-label">County:</span> {{property_county}}
    </div>
    <div class="field-group">
      <span class="field-label">Assessor's Parcel Number (APN):</span> {{property_apn}}
    </div>
    <div class="field-group">
      <span class="field-label">Legal Description:</span> {{property_legal_description}}
    </div>
  </div>
  
  <div class="section">
    <div class="section-title">Document Information</div>
    <div class="field-group">
      <span class="field-label">Document Type:</span> Private Member Contribution Assignment
    </div>
    <div class="field-group">
      <span class="field-label">Recording Requested By:</span> {{una_name}}
    </div>
    <div class="field-group">
      <span class="field-label">Prepared By:</span> {{contributor_name}}, Member
    </div>
  </div>
  
  <div class="section">
    <div class="section-title">Parties to Transaction</div>
    <div class="field-group">
      <span class="field-label">Contributor (Assignor):</span> {{contributor_name}}
    </div>
    <div class="field-group">
      <span class="field-label">Receiving Entity (Assignee):</span> {{receiving_entity}}
    </div>
    <div class="field-group">
      <span class="field-label">Ecclesiastical Association:</span> {{una_name}}
    </div>
  </div>
  
  <div class="section">
    <div class="section-title">Return Documents To</div>
    <div class="field-group">
      {{una_name}}<br>
      {{una_address}}<br>
      {{una_city}}, {{una_state}} {{una_zip}}<br>
      Attn: {{primary_officer_role}}
    </div>
  </div>
  
  <div class="instruction-box">
    <div class="instruction-title">Recording Instructions:</div>
    <div style="margin: 8pt 0;">
      <span class="checkbox"></span> Record this document as a private ecclesiastical assignment
    </div>
    <div style="margin: 8pt 0;">
      <span class="checkbox"></span> No documentary transfer tax applies (private ecclesiastical transfer)
    </div>
    <div style="margin: 8pt 0;">
      <span class="checkbox"></span> Exempt from Preliminary Change of Ownership Report (ecclesiastical transfer)
    </div>
    <div style="margin: 8pt 0;">
      <span class="checkbox"></span> Return recorded documents to address above
    </div>
  </div>
  
  <div class="footer">
    This cover sheet prepared {{current_date}}<br>
    For ecclesiastical record-keeping purposes
  </div>
</body>
</html>
  `;
  
  return replaceMergeFields(template, mergeFields);
}
